import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import UserSync from './UserSync';
import PostHogSync from './PostHogSync';

const DataSync = (props) => {
  return (
    <>
      <UserSync />
      <PostHogSync />
    </>
  );
};

DataSync.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(DataSync);
